/**
 * wheelilbin — the public entry point.
 *
 * Ten lines by design (BRIEF §14): import core, import the skin, mount.
 * Everything project-specific lives in `skin/`. Do not add logic here — if
 * something does not fit in a skin, it belongs in `@remidus/web-core`.
 */

import '@remidus/web-core/tokens.css'
import './skin/tokens.css'
import './skin/skin.css'

import { mountSite } from '@remidus/web-core'

import skin from './skin/skin'
import { attachSharedAssets } from './skin/assets/shared'

attachSharedAssets()
// `basePath` is not optional in practice. Only this module knows the project's
// base: `import.meta.env.BASE_URL` inside the published core is core's own
// build base (`/`). Omit it and the page will work in dev — where the project
// owns the root of its own port — and fail to hydrate in production, where the
// hub owns `location /`. See docs/DECISIONS.md.
void mountSite({ skin, basePath: import.meta.env.BASE_URL })
